<template>
    <b-container class="wrapper h-100" fluid>
        <b-modal id="modal-frontstage" size="xl" centered hide-footer hide-header content-class="modal-fs">
            <div><b-icon class="close" icon="x" @click="closeModal"></b-icon></div>
            <b-row class="h-100 first" align-v="center" align-h="center">
                <b-col class="content-col" col xs="12" sm="12" md="12" xl="7" lg="7">
                    <p class="title">Economía del<br><span class="green-txt">Comportamiento</span></p>
                    <br><br>
                    <p class="body">Detona cambios simples que generen grandes impactos, utilizando ciencias del comportamiento y psicología de las personas.</p>
                    <br><br>
                    <p class="body green-txt">Viernes 8 de Octubre<br>4:00 pm - 7:00 pm</p>
                    <br><br>
                    <p class="cta">
                        <b-button class="ozmo-btn-outline" @click="launchWorkshop">Conoce más</b-button>
                    </p>
                </b-col>
                <b-col col xs="12" sm="12" md="12" xl="5" lg="5"></b-col>
            </b-row>
        </b-modal>
        <video autoplay muted loop class="video-bgnd">
            <source src="../assets/agencia-de-consultoria-organizacional.webm" type="video/webm">
        </video>
        <b-row class="h-100 first" align-v="center" align-h="center">
            <b-col class="center-msg" col xs="8" sm="8" md="8" xl="8" lg="8">
                <h1>Consultoría en innovación de:</h1>
                <div class="animation-wrap">
                    <p class="filler">filler</p>
                    <h2 class="msg msg1">Productos</h2>
                    <h2 class="msg msg2">Servicios</h2>
                    <h2 class="msg msg3">Procesos</h2>
                    <h2 class="msg msg4">Experiencias</h2>
                    <h2 class="msg msg5">Capital Humano</h2>
                    <h2 class="msg msg6">Modelos de Negocio</h2>
                    <h2 class="msg msg7">Cultura Organizacional</h2>
                    <h2 class="msg msg8">Sociedad</h2>
                </div>
                <b-button class="ozmo-btn" @click="goto('/servicios')">Conoce más</b-button>
                <b-button  class="ozmo-btn-outline mobile " @click="launchContact">Contáctanos</b-button>
            </b-col>
        </b-row>
        <b-row class="second" align-v="center" align-h="center">
            <b-col class="" col xs="8" sm="8" md="8" xl="8" lg="8">
                <img class="poster-img" src="../assets/ozmo-agencia-en-innovacion.png" alt="ozmo innovacion">
            </b-col>
        </b-row>
        <b-row class="third" align-h="center">
            <b-row class="inner" align-h="center">
                <b-col col xs="8" sm="8" md="8" xl="8" lg="8">
                    <p class="head"><br>Somos una consultora en innovación estratégica creando soluciones de alto impacto.</p>
                    <p class="head"><br>¿Qué hacemos?<br><br></p>
                    <p class="icon my-0"><b-icon icon="arrow-down"></b-icon></p>
                </b-col>
            </b-row>
            <b-row class="outter" align-v="center" align-h="center">
                <b-col class="" col xs="8" sm="8" md="8" xl="8" lg="8">
                    <b-row align-h="center">
                        <b-col class="service-link" @click="goto('/innovacion-basada-en-datos')" col xs="8" sm="8" md="8" xl="4" lg="4">
                            <p class="text">Innovación<br>basada en datos.</p>
                            <p class="icon my-0"><b-icon icon="arrow-right"></b-icon></p>
                        </b-col>
                        <b-col class="service-link" @click="goto('/investigacion-de-usuarios')" col xs="8" sm="8" md="8" xl="4" lg="4">
                            <p class="text">Investigación<br>de usuarios.</p>
                            <p class="icon my-0"><b-icon icon="arrow-right"></b-icon></p>
                        </b-col>
                        <b-col class="service-link" @click="goto('/innovacion-en-capital-humano')" col xs="8" sm="8" md="8" xl="4" lg="4">
                            <p class="text">Innovación en<br>capital humano.</p>
                            <p class="icon my-0"><b-icon icon="arrow-right"></b-icon></p>
                        </b-col>
                    </b-row>
                    <br><br>
                    <b-row align-h="center">
                        <b-col class="service-link" @click="goto('/diseno-de-servicios')" col xs="8" sm="8" md="8" xl="4" lg="4">
                            <p class="text">Diseño de<br>servicios.</p>
                            <p class="icon my-0"><b-icon icon="arrow-right"></b-icon></p>
                        </b-col>
                        <b-col class="service-link" @click="goto('/arquitectura-de-decisiones')" col xs="8" sm="8" md="8" xl="4" lg="4">
                            <p class="text">Arquitectura<br>de decisiones.</p>
                            <p class="icon my-0"><b-icon icon="arrow-right"></b-icon></p>
                        </b-col>
                        <b-col class="service-link" @click="goto('/workshops-para-organizaciones')" col xs="8" sm="8" md="8" xl="4" lg="4">
                            <p class="text">Workshops para<br>organizaciones.</p>
                            <p class="icon my-0"><b-icon icon="arrow-right"></b-icon></p>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-row>
        <b-row class="fourth" align-v="center" align-h="center">
            <b-col col xs="8" sm="8" md="8" xl="8" lg="8">
                <p class="head">Ellos han confiado en nosotros:<br><br></p>
                <div class="animation-wrap">
                    <b-row class="client-slider0"></b-row>
                    <b-row class="client-slider client-slider1" align-v="center" align-h="center">
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-GBM.png" alt="GBM">
                        </b-col>
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-KIO.png" alt="KIO Networks">
                        </b-col>
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-BBVA.png" alt="BBVA">
                        </b-col>
                    </b-row>
                    <b-row class="client-slider client-slider2" align-v="center" align-h="center">
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-Posadas.png" alt="Posadas">
                        </b-col>
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-AXA.png" alt="AXA">
                        </b-col>
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-KC.png" alt="Kimberly-Clark">
                        </b-col>
                    </b-row>
                    <b-row class="client-slider client-slider3" align-v="center" align-h="center">
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-ITESM.png" alt="Tec de Monterrey">
                        </b-col>
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-UIA.png" alt="Universidad Iberoamericana">
                        </b-col>
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-UP.png" alt="Universidad Panamericana">
                        </b-col>
                    </b-row>
                    <b-row class="client-slider client-slider4" align-v="center" align-h="center">
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-Enlight.png" alt="Enlight">
                        </b-col>
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-Mexxico.png" alt="Mexxico">
                        </b-col>
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-Findep.png" alt="Financiera Independencia">
                        </b-col>
                    </b-row>
                    <b-row class="client-slider client-slider5" align-v="center" align-h="center">
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-SB.png" alt="Startupbootcamp">
                        </b-col>
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-IH.png" alt="Iron Hack">
                        </b-col>
                        <b-col class="client-img" col xs="8" sm="8" md="4" xl="4" lg="4">
                            <img src="../assets/clients/Logo-SDMX.png" alt="Dervice Design México">
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
        <b-row class="fifth h-100" align-v="center" align-h="center">
        <b-row class="slider-bgnd exito1">
        <b-row class="slider-cover" align-v="start" align-h="center">
            <b-col col xs="8" sm="8" md="8" xl="8" lg="8">
                <p class="head"><br>Casos de éxito:<br><br></p>

                <b-row class="success-slider1" align-v="start" align-h="start">
                    <b-col col xs="8" sm="8" md="5" xl="5" lg="5">
                        <h2>Innovación basada en datos.</h2>
                        <br>
                        <p class="text"><br>Generamos certidumbre para enfocar los recursos en ideas ganadoras al invertir en innovación.</p>
                        <p>&nbsp;</p>
                    </b-col>
                </b-row>
                <b-row class="success-slider2" align-v="start" align-h="start">
                    <b-col col xs="8" sm="8" md="5" xl="5" lg="5">
                        <h2>Investigación de Usuarios.</h2>
                        <br>
                        <p class="text"><br>Creamos una base de clientes fidelizada e incrementamos tus ventas a través del conocimiento profundo de tus usuarios a profundidad.</p>
                        <p>&nbsp;</p>
                    </b-col>
                </b-row>
                <b-row class="success-slider3" align-v="start" align-h="start">
                    <b-col col xs="8" sm="8" md="5" xl="5" lg="5">
                        <h2>Innovación en Capital Humano.</h2>
                        <br>
                        <p class="text"><br>Diseñamos una cultura enfocada en tus colaboradores para generar compromiso, sentido de pertenencia, autonomía y capacidad de innovación.</p>
                        <p>&nbsp;</p>
                    </b-col>
                </b-row>
                <b-row class="success-slider4" align-v="start" align-h="start">
                    <b-col col xs="8" sm="8" md="5" xl="5" lg="5">
                        <h2>Diseño de servicios.</h2>
                        <br>
                        <p class="text"><br>Creamos servicios que generen experiencias inolvidables para tus clientes y hagan uso eficiente de los recursos.</p>
                        <p>&nbsp;</p>
                    </b-col>
                </b-row>
                <b-row class="success-slider5" align-v="start" align-h="start">
                    <b-col col xs="8" sm="8" md="6" xl="6" lg="6">
                        <h2>Arquitectura de decisiones y cambio del comportamiento.</h2>
                        <br>
                        <p class="text"><br>Diseñamos cambios simples con base en las ciencias del comportamiento y la psicología de las personas que generan impactos de gran escala.</p>
                        <p>&nbsp;</p>
                    </b-col>
                </b-row>
                <b-row class="success-slider6" align-v="start" align-h="start">
                    <b-col col xs="8" sm="8" md="6" xl="6" lg="6">
                        <h2>Workshops para Organizaciones.</h2>
                        <br>
                        <p class="text"><br>Nuestros consultores expertos ayudan a tu equipo a conducir procesos rápidos de innovación. Así pueden crear más oportunidades mientras desarrollan nuevas capacidades.</p>
                        <p>&nbsp;</p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        </b-row>
        </b-row>
        <b-row class="sixth" align-v="center" align-h="center">
            <b-col class="section-wrapper" col xs="8" sm="8" md="8" xl="8" lg="8">
                <b-row class="no-margin" align-v="center" align-h="center">
                    <b-col col xs="12" sm="12" md="12" xl="12" lg="12">
                        <p class="head no-margin">¿Quieres hablar<br>con un experto?</p>
                    </b-col>
                </b-row>
                <b-row class="no-margin" align-v="center" align-h="center">
                    <b-col col xs="12" sm="12" md="12" xl="12" lg="12">
                        <p class="image-placeholder">
                            <img src="../assets/ozmo-agencia-innovacion-organizacional.png" alt="ozmo designer">
                        </p>
                    </b-col>
                </b-row>
                <b-row align-v="center" align-h="center">
                    <b-col class="align-center" col xs="12" sm="12" md="12" xl="12" lg="12">
                        <b-button class="ozmo-btn-outline-green" @click="launchContact">Contáctanos</b-button>
                    </b-col>
                </b-row>
                <b-row align-v="center" align-h="center">
                    <b-col class="align-center" col xs="12" sm="12" md="12" xl="12" lg="12">
                        <b-button class="ozmo-btn-outline" @click="launchPhoneEvent">55 9225 3233</b-button>
                    </b-col>
                </b-row>
                <b-row class="social" align-v="center" align-h="center">
                    <b-col col xs="3" sm="3" md="3" xl="3" lg="3">
                        <b-row align-v="center" align-h="center">
                            <b-col class="social-img" col xs="3" sm="3" md="3" xl="3" lg="3">
                                <a href="https://www.facebook.com/OZMOmx" target="_blank"><img src="../assets/social/ozmo-facebook.png" alt="facebook"></a>
                            </b-col>
                            <b-col class="social-img" col xs="3" sm="3" md="3" xl="3" lg="3">
                                <a href="https://www.linkedin.com/company/ozmo-futures-design" target="_blank"><img src="../assets/social/ozmo-linkedin.png" alt="LinkedIn"></a>
                            </b-col>
                            <b-col class="social-img" col xs="3" sm="3" md="3" xl="3" lg="3">
                                <a href="https://twitter.com/OzmoFutures" target="_blank"><img src="../assets/social/ozmo-twitter.png" alt="Twitter"></a>
                            </b-col>
                            <b-col class="social-img" col xs="3" sm="3" md="3" xl="3" lg="3">
                                <a href="https://www.instagram.com/ozmofutures" target="_blank"><img src="../assets/social/ozmo-instagram.png" alt="Instagram"></a>
                            </b-col>
                        </b-row>
                    </b-col>                    
                </b-row>
                <b-row class="no-margin" align-v="center" align-h="center">
                    <b-col col xs="12" sm="12" md="12" xl="12" lg="12">
                        <p class="footnote">© {{currentDate}} Ozmo Futures Design</p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

import { gsap } from "gsap"
import { TimelineLite, Sine } from "gsap"
import * as typeformEmbed from '@typeform/embed'

gsap.registerPlugin()

import { eventBus } from '../main'

export default {
    name: 'Home',
    data() {
        return {}
    },
    metaInfo() {
        return {
            title: 'Agencia de innovación estratégica | Ozmo',
            meta: [
                {name: 'description', content: 'Somos una consultora de innovación de experiencias, modelos de negocio, cultura organizacional, productos, procesos, servicios y más. ¡Contáctanos!'},
                {name: 'keywords', content: 'Agencia de innovación estratégica, consultora de innovación, agencia de transformación estratégica, consultora de cultura organizacional, consultoría en transformación para empresas, consultoría en cultura organizacional, proveedores de design thinking, agencias de investigación de usuarios, talleres para diseñar experiencias, consultoras con experiencia en área de capital humano, consultoras en innovación con experiencia sector financiero, agencia de innovación empresarial'},
                {name: 'robots', content: 'index,follow'},
                {name: 'viewport', content: 'width=device-width,initial-scale=1,user-scalable=no' },
                {charset: 'utf-8' },
                {property: 'og:title', content: 'Agencia de innovación estratégica | Ozmo'},
                {property: 'og:site_name', content: 'Ozmo | Diseño de futuros'},
                {property: 'og:description', content: 'Somos una consultora de innovación de experiencias, modelos de negocio, cultura organizacional, productos, procesos, servicios y más. ¡Contáctanos!'},
                {property: 'og:url', content: 'https://ozmo.mx'},
                {property: 'og:type', content: 'website'},
                {property: 'og:image', content: 'https://s3-us-west-2.amazonaws.com/cdn.ozmo.mx/ozmo_coral.png'}
            ]
        }
    },
    computed: {
        currentDate() {
            const today = new Date();
            return today.getFullYear();
        }
    },
    methods: {
        goto(navigation) {
            eventBus.$emit('gotoNavigation', navigation)
        },
        launchProspector() {
            typeformEmbed.makePopup(
                'https://ozmomx.typeform.com/to/vwqXW6',
                {
                    mode: 'drawer_right',
                    autoOpen: true,
                    autoClose: 15,
                    hideScrollbars: true,
                    onSubmit: function () {}
                }
                )
        },
        launchContact() {
            typeformEmbed.makePopup(
                // `https://ozmomx.typeform.com/to/dTWHb81Q?source=web-${this.$route.name}`,
                // 'https://ozmomx.typeform.com/to/YPa8WK93?utm_source=website&utm_medium=section&utm_campaign=website2022&utm_content=home',
                'https://www.cognitoforms.com/Kinit1/ContactoWeb?entry={"Leads":{"Ref":"website-HOME"}}',
                {
                    mode: 'drawer_right',
                    autoOpen: true,
                    autoClose: 15,
                    hideScrollbars: true,
                    onSubmit: function () {}
                }
            )
        },
        launchWorkshop() {
            window.open('https://academy.ozmo.mx/taller-economia-comportamiento/?utm_source=pop_up&utm_medium=Organic_Social&utm_campaign=Pop_up_taller_web_CH', '_blank');
        },
        launchPhoneEvent() {
            window.location='tel:5592253233'
            this.$gtag.event('clic', {
                'event_category': 'telefono',
                'event_label': 'exitoso',
                'value': 'exitoso'
            });
        },
        closeModal() {
            this.$bvModal.hide('modal-frontstage')
        }
    },
    mounted() {
        // Launch FrontStage modal
        // this.$bvModal.show('modal-frontstage')


        // const { msg1, msg2 } = this.$refs
        const timeline_first = new TimelineLite({ repeat: -1 })

        timeline_first.fromTo('.msg1', 1, {autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'block',
            autoAlpha: 1
        })

        timeline_first.to({}, 2, {});

        timeline_first.to('.msg1', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            display: 'none'
        })

        timeline_first.fromTo('.msg2', 1, {autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'block',
            autoAlpha: 1
        })

        timeline_first.to({}, 2, {});

        timeline_first.to('.msg2', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            display: 'none'
        })

        timeline_first.fromTo('.msg3', 1, {autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'block',
            autoAlpha: 1
        })

        timeline_first.to({}, 2, {})

        timeline_first.to('.msg3', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            display: 'none'
        })

        timeline_first.fromTo('.msg4', 1, {autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'block',
            autoAlpha: 1
        })

        timeline_first.to({}, 2, {})

        timeline_first.to('.msg4', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            display: 'none'
        })

        timeline_first.fromTo('.msg5', 1, {autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'block',
            autoAlpha: 1
        })

        timeline_first.to({}, 2, {})

        timeline_first.to('.msg5', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            display: 'none'
        })

        timeline_first.fromTo('.msg6', 1, {autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'block',
            autoAlpha: 1
        })

        timeline_first.to({}, 2, {})

        timeline_first.to('.msg6', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            display: 'none'
        })

        timeline_first.fromTo('.msg7', 1, {autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'block',
            autoAlpha: 1
        })

        timeline_first.to({}, 2, {})

        timeline_first.to('.msg7', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            display: 'none'
        })

        timeline_first.fromTo('.msg8', 1, {autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'block',
            autoAlpha: 1
        })

        timeline_first.to({}, 2, {})

        timeline_first.to('.msg8', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            display: 'none',
        })

        //////////////////////////////////////////////////

        const timeline_fourth = new TimelineLite({ repeat: -1 })

        timeline_fourth.fromTo('.client-slider1', 1, {display:'none',x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'flex',
            autoAlpha: 1,
            x: 0
        })

        timeline_fourth.to({}, 2, {});

        timeline_fourth.to('.client-slider1', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            x: -999,
            display: 'none',
        })

        timeline_fourth.fromTo('.client-slider2', 1, {display:'none',x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'flex',
            autoAlpha: 1,
            x: 0
        })

        timeline_fourth.to({}, 2, {});

        timeline_fourth.to('.client-slider2', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            x: -999,
            display: 'none',
        })

        timeline_fourth.fromTo('.client-slider3', 1, {display:'none',x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'flex',
            autoAlpha: 1,
            x: 0
        })

        timeline_fourth.to({}, 2, {});

        timeline_fourth.to('.client-slider3', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            x: -999,
            display: 'none',
        })

        timeline_fourth.fromTo('.client-slider4', 1, {display:'none',x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'flex',
            autoAlpha: 1,
            x: 0
        })

        timeline_fourth.to({}, 2, {});

        timeline_fourth.to('.client-slider4', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            x: -999,
            display: 'none',
        })

        timeline_fourth.fromTo('.client-slider5', 1, {display:'none',x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'flex',
            autoAlpha: 1,
            x: 0
        })

        timeline_fourth.to({}, 2, {});

        timeline_fourth.to('.client-slider5', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            x: -999,
            display: 'none',
        })

        //////////////////////////////////////////////////


        const timeline_fifth = new TimelineLite({ repeat: -1 })

        timeline_fifth.fromTo('.success-slider1', 1, {display:'none',x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display: 'flex',
            autoAlpha: 1,
            x: 0
        })

        timeline_fifth.to({}, 6, {});

        timeline_fifth.to('.success-slider1', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            x: -999,
            display: 'none'
        })

        timeline_fifth.to('.slider-cover', 1, {
            ease: Sine.easeInOut,
            backgroundImage: "linear-gradient(to right, #000000, #000000)"
        })
        timeline_fifth.set('.slider-bgnd', {
            className: 'slider-bgnd exito2'
        })
        timeline_fifth.to('.slider-cover', 1, {
            ease: Sine.easeInOut,
            backgroundImage: "linear-gradient(to right, transparent, transparent)"
        })

        timeline_fifth.fromTo('.success-slider2', 1, {display:'none',x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display:'flex',
            autoAlpha: 1,
            x: 0
        })

        timeline_fifth.to({}, 6, {});

        timeline_fifth.to('.success-slider2', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            x: -999,
            display: 'none'
        })

        timeline_fifth.to('.slider-cover', 1, {
            ease: Sine.easeInOut,
            backgroundImage: "linear-gradient(to right, #000000, #000000)"
        })
        timeline_fifth.set('.slider-bgnd', {
            className: 'slider-bgnd exito3'
        })
        timeline_fifth.to('.slider-cover', 1, {
            ease: Sine.easeInOut,
            backgroundImage: "linear-gradient(to right, transparent, transparent)"
        })

        timeline_fifth.fromTo('.success-slider3', 1, {display:'none',x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display:'flex',
            autoAlpha: 1,
            x: 0
        })

        timeline_fifth.to({}, 6, {})

        timeline_fifth.to('.success-slider3', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            x: -999,
            display: 'none'
        })

        timeline_fifth.to('.slider-cover', 1, {
            ease: Sine.easeInOut,
            backgroundImage: "linear-gradient(to right, #000000, #000000)"
        })
        timeline_fifth.set('.slider-bgnd', {
            className: 'slider-bgnd exito4'
        })
        timeline_fifth.to('.slider-cover', 1, {
            ease: Sine.easeInOut,
            backgroundImage: "linear-gradient(to right, transparent, transparent)"
        })

        timeline_fifth.fromTo('.success-slider4', 1, {display:'none',x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display:'flex',
            autoAlpha: 1,
            x: 0
        })

        timeline_fifth.to({}, 6, {})

        timeline_fifth.to('.success-slider4', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            x: -999,
            display: 'none'
        })

        timeline_fifth.to('.slider-cover', 1, {
            ease: Sine.easeInOut,
            backgroundImage: "linear-gradient(to right, #000000, #000000)"
        })
        timeline_fifth.set('.slider-bgnd', {
            className: 'slider-bgnd exito5'
        })
        timeline_fifth.to('.slider-cover', 1, {
            ease: Sine.easeInOut,
            backgroundImage: "linear-gradient(to right, transparent, transparent)"
        })

        timeline_fifth.fromTo('.success-slider5', 1, {display:'none',x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display:'flex',
            autoAlpha: 1,
            x: 0
        })

        timeline_fifth.to({}, 6, {})

        timeline_fifth.to('.success-slider5', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            x: -999,
            display: 'none'
        })

        timeline_fifth.to('.slider-cover', 1, {
            ease: Sine.easeInOut,
            backgroundImage: "linear-gradient(to right, #000000, #000000)"
        })
        timeline_fifth.set('.slider-bgnd', {
            className: 'slider-bgnd exito6'
        })
        timeline_fifth.to('.slider-cover', 1, {
            ease: Sine.easeInOut,
            backgroundImage: "linear-gradient(to right, transparent, transparent)"
        })

        timeline_fifth.fromTo('.success-slider6', 1, {display:'none',x:999,autoAlpha:0}, {
            ease: Sine.easeInOut,
            display:'flex',
            autoAlpha: 1,
            x: 0
        })

        timeline_fifth.to({}, 6, {})

        timeline_fifth.to('.success-slider6', 1, {
            ease: Sine.easeInOut,
            autoAlpha: 0,
            x: -999,
            display: 'none'
        })

        timeline_fifth.to('.slider-cover', 1, {
            ease: Sine.easeInOut,
            backgroundImage: "linear-gradient(to right, #000000, #000000)"
        })
        timeline_fifth.set('.slider-bgnd', {
            className: 'slider-bgnd exito1'
        })
        timeline_fifth.to('.slider-cover', 1, {
            ease: Sine.easeInOut,
            backgroundImage: "linear-gradient(to right, transparent, transparent)"
        })

    },
    created() {
        eventBus.$emit('displayOverlay')
    }
}
</script>

<style scoped lang="stylus">

.msg2,.msg3,.msg4,.msg5,.msg6,.msg7,.msg8
    display none

.animation-wrap
    position relative

/deep/ .modal-fs
    background-color transparent
    border none

    .close
        cursor pointer
        background-color black
        border-radius 90px
        txt_style($worksans-b, 70px, #FFFFFF)
        position absolute
        right -30px
        top -30px

    .modal-body
        background-image url(../assets/modal_fs_bgnd.jpg)
        background-position center right
        border-radius 25px
        padding 75px

    .content-col
        .title
            line-height 52px
            txt_style($archia-m, 52px, #FFFFFF)

        .body
            txt_style($worksans-r, 24px, #FFFFFF)

        .green-txt
            color $ozmo-green


.wrapper
    width 100vw
    overflow-x hidden
    overflow-y scroll

    .video-bgnd
        position fixed
        right 0
        bottom 0
        min-width 100%
        min-height 100%
        z-index -1
        background-image url(../assets/home_bgnd.jpg)
        background-repeat no-repeat
        background-size cover
        background-color black

    .first
        // display none

        .center-msg
            text-align center

            .ozmo-btn
                margin-top 10rem

            .mobile  
                display none    

            h1, h2
                line-height 88px
                txt_style($archia-m, 80px, #FFFFFF)
                margin-bottom 5rem

            .msg
                txt_style($archia-m, 90px, $ozmo-coral)
                position absolute
                top 0
                bottom 0
                left 0
                right 0
                margin 0 auto

            p.filler
                txt_style($archia-m, 90px, $ozmo-coral)
                margin-bottom 0
                opacity 0

    .second
        // display none

        background-color $ozmo-coral
        height 65%

        .poster-img
            width 100%

    .third
        // display none

        background-image url(../assets/bg_third.jpg)
        background-repeat no-repeat
        background-size cover
        background-color black
        height 200% !important

        .inner
            position relative
            top -1px
            background-color $ozmo-coral
            shape-outside circle()
            clip-path circle(64% at 50% -5%)
            width 100%
            height 50% !important

            .head
                txt_style($archia-m, 48px, #FFFFFF)
    
            .icon
                text-align center
                txt_style($archia-m, 80px, #FFFFFF)

        .outter
            width 100%
            height 50% !important

            .service-link
                cursor pointer

            .text
                txt_style($archia-m, 28px, #FFFFFF)

            .icon
                txt_style($archia-m, 48px, #FFFFFF)

    .fourth
        // display none

        background-color $ozmo-blue
        padding-top 20rem
        padding-bottom 20rem

        .head
            text-align center
            txt_style($archia-m, 48px, #FFFFFF)

        .client-slider
            position absolute
            top 0
            right 0
            bottom 0
            left 0
            margin 0 auto

        .client-slider0
            height 200px

        .client-img
            text-align center
                
            img
                height 200px
    
    .fifth
        // display none

        background-color #000000

        .slider-bgnd
            background-repeat no-repeat
            background-size cover
            background-position center center
            width 100%
            height 100%

        .exito1
            background-image url(../assets/caso-de-exito-innovacion-basada-en-datos.jpg)

        .exito2
            background-image url(../assets/caso-de-exito-estudio-e-investigacion-de-usuarios.jpg)
        
        .exito3
            background-image url(../assets/caso-de-exito-innovacion-en-cultura-y-capital-humano.jpg)

        .exito4
            background-image url(../assets/caso-de-exito-diseno-de-servicios.jpg)

        .exito5
            background-image url(../assets/caso-de-exito-arquitectura-de-decisiones-y-cambio-del-comportamiento.jpg)

        .exito6
            background-image url(../assets/caso-de-exito-workshops-para-organizaciones.jpg)


        .slider-cover
            background-image linear-gradient(to right, transparent, transparent)
            width 100%
            height 100%
            margin 0


        .head
            txt_style($archia-m, 48px, #FFFFFF)

        h2
            txt_style($archia-m, 48px, $ozmo-green)

        .text
            txt_style($worksans-r, 24px, #FFFFFF)

        img
            width 50%
         

    .sixth
        background-color black
        padding-top 10rem
        padding-bottom 10rem

        button
            font-size 28px !important
            width 300px

        .row
            margin-top 5rem
            margin-bottom 5rem

        .head
            text-align center
            txt_style($archia-m, 48px, #FFFFFF)

        .head2
            text-align center
            txt_style($archia-m, 32px, #FFFFFF)
            padding 2rem 0

        .footnote
            text-align center
            txt_style($worksans-r, 16px, #FFFFFF)

        .social

            .social-img

                img
                    width 75%

        .image-placeholder
            text-align center
            margin 5rem 0

            img
                width 40%

@media screen and (max-width : 768px)

    /deep/ .modal-fs

        .close
            cursor pointer
            background-color black
            border-radius 90px
            txt_style($worksans-b, 40px, #FFFFFF)
            position absolute
            right -15px
            top -15px

        .modal-body
            background-position 70% 50%
            border-radius 25px
            padding 50px 25px

        .content-col
            .title
                line-height 36px
                txt_style($archia-m, 36px, #FFFFFF)

            .body
                txt_style($worksans-r, 16px, #FFFFFF)

    .wrapper

        .first

            .center-msg
                text-align center

                .ozmo-btn
                    margin-top 15rem

                .mobile  
                    width 250px
                    margin-top 32px  
                    display initial    

                h1
                    line-height 44px
                    txt_style($archia-m, 36px, #FFFFFF)
                    margin-bottom 5rem

                .msg
                    txt_style($archia-m, 40px, $ozmo-coral)
                    line-height 55px
                    position absolute
                    top 0
                    bottom 0
                    left 0
                    right 0
                    margin 0 auto

                p.filler
                    txt_style($archia-m, 40px, $ozmo-coral)
                    margin-bottom 0
                    opacity 0           

        .second
            background-color $ozmo-coral
            height 50%

        .third
            height 245% !important

            .inner
                top -8%
                clip-path circle(68% at 50% -6%)
                width 100%
                height 90% !important

                .head
                    txt_style($archia-m, 32px, #FFFFFF)
        
                .icon
                    text-align center
                    txt_style($archia-m, 70px, #FFFFFF)

            .outter
                margin-top -265% !important
                width 84%
                height 50% !important

                .text
                    txt_style($archia-m, 28px, #FFFFFF)

                .icon
                    txt_style($archia-m, 48px, #FFFFFF)                      
                        

        .fourth
            padding-top 10rem
            padding-bottom 20rem

            .head
                txt_style($archia-m, 32px, #FFFFFF)

            .client-slider0
                height 140px

            .client-img
                text-align center
                    
                img
                    height 140px                

        .fifth

            .slider-bgnd
                background-position left

            .head
                margin-top 5rem
                margin-left 2rem
                txt_style($archia-m, 32px, #FFFFFF)

            h2
                margin-left 1rem
                txt_style($archia-m, 30px, $ozmo-green)

            .text
                margin-left 1rem
                txt_style($worksans-r, 16px, #FFFFFF)

            img
                width 10%         

        .sixth
            button
                font-size 16px !important
                width 200px

            .head
                txt_style($archia-m, 32px, #FFFFFF)

            .head2
                txt_style($archia-m, 20px, #FFFFFF)

            .footnote
                txt_style($worksans-r, 12px, #FFFFFF)

            .social
                width  84%
                margin-left 10%

                .social-img

                    img
                        width 60%

            .image-placeholder
                text-align center

                img
                    width 80%                      

@media screen and (min-width 768px) and (max-width 1024px)

    .wrapper

        .first

            .center-msg
                text-align center

                .ozmo-btn
                    margin-top 15rem
 
                h1
                    line-height 68px
                    txt_style($archia-m, 60px, #FFFFFF)
                    margin-bottom 5rem

                .msg
                    txt_style($archia-m, 70px, $ozmo-coral)
                    line-height 80px

                p.filler
                    txt_style($archia-m, 90px, $ozmo-coral)
                    margin-bottom 0
                    opacity 0           

        .second
            background-color $ozmo-coral
            height 55%

            .poster-img
                margin-top -20%

        .third
            margin-top -300px !important
            background-position center
            height 170% !important

            .inner
                clip-path circle(68% at 50% -6%)
                width 100%
                height 75% !important

                .head
                    text-align center
                    txt_style($archia-m, 44px, #FFFFFF)
        
                .icon
                    text-align center
                    txt_style($archia-m, 70px, #FFFFFF)

            .outter
                margin-top -685px !important
                width 100%
                height 10% !important

                .text
                    width 150% !important
                    txt_style($archia-m, 26px, #FFFFFF)

                .icon
                    txt_style($archia-m, 48px, #FFFFFF)                       
                        

</style>
